// -- styling
import "./AppHeader.scss";
// -- Packages
import React from "react";
import { observer } from "mobx-react";
// -- Prime React
import "primeflex/primeflex.scss";
// -- Local

type Props = {};

export const AppHeader: React.FC<Props> = observer(() => {
    return (
        <>
            <link
                href="https://fonts.googleapis.com/css2?family=Inter+Tight:wght@400;700&display=swap"
                rel="stylesheet"
            />

            <header
                data-testid="app-header"
                className="top-banner"
            >
                <div className="banner-inner">
                    <div className="banner-row">

                        <div className="logo-wrap">
                            <img
                                src={"./miami-logo.png"}
                                alt="Miami-Dade County"
                                className="seal"
                            />
                        </div>

                        <div className="banner-sheriff-title">
                            <h1>Miami-Dade Sheriff Office</h1>
                            <h1>Public Services Portal</h1>
                        </div>

                    </div>
                </div>

                <div className="banner-wave wave-1" />
                <div className="banner-wave wave-2" />
                <div className="banner-wave wave-3" />
            </header>
        </>
    );
});